<template>
    <div class="row m-0">
        <div class="col-lg-4"></div>
        <div class="col-lg-4">
            <div class="d-flex justify-content-center">
                <img class="w-75" src="https://app.followupcrm.com/images/followup-horizontal-teal.png" alt="followupcrm">
            </div>
            <div class="card" id="mobilewidth" style="background-color: white; box-shadow: 0 0px 6px 2px #a0a0a0;">
                <div class="card-body">
                    <div class="container pt-2 pb-2 p-0">
                        <ul class="progressbar p-0">
                            <li class="one active"></li>
                            <li class="two" :class="{'active': (currentForm === 'two' || currentForm === 'three')}"></li>
                            <li class="three" :class="{'active': currentForm === 'three'}"></li>
                            <form-one v-show="currentForm === 'one'"></form-one>
                            <form-two v-show="currentForm === 'two'"></form-two>
                            <form-three v-show="currentForm === 'three'"></form-three>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 d-flex align-items-center">
            <div v-show="currentForm === 'one'">
                <img src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/signup-images/signup-1.png" alt="On Average, Followup CRM users see a 25% increase in closing ratios.">
            </div>
            <div v-show="currentForm === 'two'">
                <img src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/signup-images/signup-2.png" alt="On Average, Followup CRM users see a 30% increase in revenue.">
            </div>
            <div v-show="currentForm === 'three'">
                <img src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/signup-images/signup-3.png" alt="On Average, Followup CRM users see a 10+ Hours saved weekly.">
            </div>
        </div>

        <div v-show="creatingAccount" class="proposal-overlay-document">
            <div class="flex align-items-center">
                <img src="https://app.followupcrm.com/images/proposal-loader.gif" />
                <h1 class="align-center">Creating your account, please wait.</h1>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "signup-form",
    data(){
        return {
            currentForm:'one',
            uploadPercentage: 0,
            form:{
                name:null,
                role:'owner',
                email:null,
                phone:null,
                password:null,
                company_name:null,
                company_logo:null,
                selected_company_industry:null,
                selected_user:null,
                selected_options: []
            },
            validationErrors: [],
            creatingAccount: false,
            urlToken: null,
            postUrl: null,
        }
    },
    mounted() {
        const self = this
        Bus.$on('changeForm', data => {
            self.nextForm(data);
        });
        Bus.$on('updateFormData', data => {
            self.setFormData(data);
        });
        let location = new URL(window.location);
        this.urlToken = location.searchParams.get('token');
        this.postUrl = this.urlToken ? '/pre-signup-sandbox' : '/signup-sandbox';
    },
    methods: {
        nextForm: function (val){
            this.currentForm = val
        },
        setFormData: function (val) {
            const self = this;
            if (val.formNumber === 'one') {
                self.form.name = val.formData.name
                self.form.email = val.formData.email
                self.form.phone = val.formData.phone
                self.form.password = val.formData.password
                self.form.company_name = val.formData.company_name
            }
            if(val.formNumber === 'two') {
                self.form.company_logo = val.formData.logo.length > 0 ? val.formData.logo[0] : null
                self.form.selected_company_industry = val.formData.selected_company_industry
                self.form.selected_user = val.formData.selected_user
            }
            if(val.formNumber === 'three') {
                self.form.selected_options = val.formData.selected_options
            }

            if(val.formNumber === 'three'){

                let formData = new FormData();
                formData.append('name', self.form.name);
                formData.append('role', self.form.role);
                formData.append('email', self.form.email);
                formData.append('phone', self.form.phone);
                formData.append('password', self.form.password);
                formData.append('company_name', self.form.company_name);
                formData.append('company_logo', self.form.company_logo);
                formData.append('company_industry', self.form.selected_company_industry);
                formData.append('user_limit', self.form.selected_user);
                formData.append('selected_options', self.form.selected_options);
                self.creatingAccount = true;
                axios.post(this.postUrl,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        onUploadProgress: function( progressEvent ) {
                            this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
                        }.bind(this)
                    }
                ).then(response => {
                    self.creatingAccount = false
                    if(response.data.status === 'success'){
                        self.getToast().fire({
                            type: "success",
                            text: response.data.message,
                        });
                        window.location.href = '/home'
                    }else{
                        self.getToast().fire({
                            type: "error",
                            text: response.data.message,
                        });
                    }
                }).catch(error => {
                    self.creatingAccount = false;
                    console.log(error)
                    if(error.response.data.errors){
                        self.currentForm = 'one'
                        Object.entries(error.response.data.errors).map(([key, value]) => {
                            self.validationErrors[key] = value[0];
                        })
                        Bus.$emit('formValidationError', {validationErrors: self.validationErrors});
                    }else{
                        self.getToast().fire({
                            title: "Error",
                            text: "Something went wrong please try again or contact administration",
                        });
                    }
                });
            }
        }
    }
}
</script>

<style scoped>
@media only screen
and (min-device-width: 375px)
and (max-device-width: 812px)
and (-webkit-min-device-pixel-ratio: 3) {
    #mobilewidth{
        min-width: 75% !important;
    }
}

.progressbar{
    counter-reset: step;
}
.progressbar li {
    list-style-type: none;
    float: left;
    width: 33.33%;
    position: relative;
    text-align: center;
}
.progressbar li:before{
    content: counter(step);
    counter-increment: step;
    width: 30px;
    height: 30px;
    line-height: 30px;
    border: 1px solid #ddd;
    display: block;
    text-align: center;
    margin: 0 auto 10px auto;
    border-radius: 50%;
    background-color: #7f7f7f;
    color: white;
}
.progressbar li:after {
    content: '';
    position: absolute;
    width: 80%;
    height: 1px;
    background-color: grey;
    top: 15px;
    left: -40%;
    /*z-index: -1px;*/
}

.progressbar li:first-child:after {
    content: none;
}
.progressbar li.active {
    color: #01b1af;
}
.progressbar li.active:before {
    border-color: #01b1af;
    background-color: #01b1af;
}
.progressbar li.active + li:after{
    background-color: #01b1af;
}
.proposal-overlay-document{
    position: fixed;
    display: block;
    width: 100%;
    height: 100%;
    top:18px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    cursor: pointer;
    background: #ffffffd9;
}
.proposal-overlay-document img{
    position: absolute;
    left: 45%;
    top: 28%;
}
.proposal-overlay-document h1{
    position: absolute;
    color: #01b1af;
    top: 60%;
    right: 39%;
    font-weight: 200;
}
</style>
